import React, {Component, createRef} from 'react';
import logo from '../../images/bp-logo.svg';
import './AssessmentReport.css';
import moment from 'moment';
import ChiropodyExam from './ChiropodyExam';
import BiomechanicalExam from './BiomechanicalExam';
import AssessmentSignature from './AssessmentSignature';
import AssessmentAddendums from './AssessmentAddendums';
import ReactToPrint from 'react-to-print';

import AssessmentService from '../../api/services/AssessmentService';
import ClinicService from '../../api/services/ClinicService';

import { SideModal } from '../../components/BioPedModal';

class AssessmentReport extends Component {
	state = {
		assessment: null,
		report: null,
		chiropodyExam: null,
		biomechanicalExam: null,
		clinic: null,
		clinician: null,
		examType: 'Patient Exam'
	};

	printRef = createRef();

	async componentDidMount(){

		let assessment = this.props.assessmentVersion === '3' 
			? await AssessmentService.GetAssessmentV3(this.props.assessmentId)
			: await AssessmentService.GetAssessment(this.props.assessmentId);
		this.setState({assessment: assessment})

		const clinicService = new ClinicService()
		const clinic = await clinicService.getInfo(this.props.user.clinicId)
		this.setState({clinic: clinic})

		const findClinicUser = (userId) => {
			return clinic.userClinics.find((userClinic) => (
				userClinic.userId === userId
			))
		}
		const clinicUser = findClinicUser(assessment.userId)
		if (clinicUser && clinicUser.user) this.setState({clinician: clinicUser.user})

		if (assessment.biomechanicalData && Object.keys(assessment.biomechanicalData).length > 0) {
			this.setState({
				examType: 'Patient Exam - Biomechanical',
				biomechanicalExam: {
					history: assessment.historyData.data,
					exam: assessment.biomechanicalData.biomechanicalData,
					treatment: assessment.treatmentData.treatmentData
				}
			})
		}

		if (assessment.chiropodyExams && assessment.chiropodyExams.length > 0) {
			this.setState({
				examType: 'Patient Exam - Chiropody', 
				chiropodyExam: {
					history: assessment.historyData.data,
					exam: assessment.chiropodyExams[0].examData,
					treatment: assessment.treatmentData.treatmentData,
					addendums: assessment.chiropodyExams[0].addendums
				}
			})
		}

		if (!this.state.biomechanicalExam && !this.state.chiropodyExam) {
			const report = await AssessmentService.GetAssessmentReport(this.props.assessmentId)
			this.setState({report: report})
		}
	}

	createDivs = (data, level = 0, parentKey = "") => {
		return (
			<React.Fragment key={`${level}${parentKey}`}>
				{Object.entries(data).map(([key, value], index) => {
					const uniqueKey = `${level}${parentKey}${index}`
					return (
						<div className={`AssessmentReport__details AssessmentReport__details-${level}`} key={uniqueKey}>
							<h3>{key}</h3>
							{typeof value === "object" && !Array.isArray(value) ? (
								this.createDivs(value, level + 1, uniqueKey)
							) : Array.isArray(value) ? (
								value.map((item, index2) => (
									<div className="AssessmentReport__item" key={`${uniqueKey}${index2}`}>
										{item.caption && <span className="AssessmentReport__item-caption">{item.caption}:</span>} 
										<span className="AssessmentReport__item-value">{item.value || ''}</span>
									</div>
								))
							) : null}
						</div>
					)
				})}
			</React.Fragment>
		);
	};

	render() {

		const { assessment, report, clinic, clinician, examType, chiropodyExam, biomechanicalExam } = this.state
		const { user } = this.props

		if (!assessment) {
			return (
				<div className="AssessmentReport">
					<span className="Select-loading"></span>
				</div>
			)
		}

		// if (!assessment || !report) {
		// 	return (
		// 		<div className="AssessmentReport">
		// 			<span className="Select-loading"></span>
		// 		</div>
		// 	)
		// }

		// if (assessment && (report && Object.keys(report).length === 0)) {
		// 	return (
		// 		<div className="AssessmentReport">
		// 			<div>No Assessment Data Found</div>
		// 		</div>
		// 	)
		// }

		return (
			<div className="AssessmentReport" ref={this.printRef}>
				<div className="AssessmentReport__print-button-container">
					<ReactToPrint
						trigger={() => <button>Print</button>}
						content={() => this.printRef.current}
						pageStyle={`@media print { @page { margin: .25in 0; } body { -webkit-print-color-adjust: exact; } }`}
					/>
				</div>
				<div className="AssessmentReport__header-container">
					<img className="AssessmentReport__header-logo" src={logo} alt="Bioped Logo"/>
					<h1 className="AssessmentReport__header-exam-type">{examType}</h1>
				</div>
				{clinic && (
					<div className="AssessmentReport__location-container">
						{clinic.name && <div><strong>{clinic.name}</strong></div>}
						{clinic.address && <div>{clinic.address},</div>}
						<div>{`${clinic.city && clinic.city}, ${clinic.province && clinic.province} ${clinic.postalCode && clinic.postalCode}`}</div>
					</div>
				)}
				<div className="AssessmentReport__clinician-patient-container">
					<div className="AssessmentReport__clinician-details">
						<h2>Exam Clinician</h2>
						<div>{(clinician && clinician.firstName) && clinician.firstName} {(clinician && clinician.lastName) && clinician.lastName}</div>
						<div>{(clinician && clinician.title) && clinician.title}</div>
						<div className='email'>{(clinician && clinician.email) && `email: ${clinician.emailAddress}`}</div>
					</div>
					<div className="AssessmentReport__patient-details">
						<h2>Patient Info</h2>
						<div>{`${user.firstName} ${user.lastName}`}</div>
						<div className='tel'>
							{(user.cellPhone && `Tel.: ${user.cellPhone}`) || 
							(user.homePhone && `Tel.: ${user.homePhone}`) ||
							(user.workPhone && `Tel.: ${user.workPhone}`)}
						</div>
						{user.email && <div className='email'>Email: {user.email}</div>}
						{user.birthDate && <div className='dob'>DOB: {moment(user.birthDate).format('MMM D, YYYY')}</div>}
					</div>
				</div>
				<div className="AssessmentReport__assessment-container">
					<div className="AssessmentReport__assessment-date">
						<h3>Assessment Date: {moment(assessment.created).format('MMM D, YYYY')}</h3>
					</div>
					<div className="AssessmentReport__assessment-id">
						<h3>Assessment ID: {this.props.assessmentId}</h3>
					</div>
				</div>
				{report && this.createDivs(this.state.report)}
				{chiropodyExam && <ChiropodyExam data={chiropodyExam} />}
				{biomechanicalExam && <BiomechanicalExam data={biomechanicalExam} />}
				{(chiropodyExam || biomechanicalExam) && <AssessmentSignature className="AssessmentReport__page-break-avoid" clinician={clinician} />}
				{(chiropodyExam && chiropodyExam.addendums.length > 0) && <AssessmentAddendums addendums={chiropodyExam.addendums} />}
			</div>
		);
	}
}
 
export class AssessmentReportSideBar extends Component{
	render(){
		return(
			<SideModal {...this.props}><AssessmentReport user={this.props.user} assessmentId={this.props.id} assessmentVersion={this.props.version}/></SideModal>
		)
	}
}


// WEBPACK FOOTER //
// ./src/views/Assessment/AssessmentReport.js